webpackJsonp([30],{

/***/ 1120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _keys = __webpack_require__(38);

var _keys2 = _interopRequireDefault(_keys);

var _round = __webpack_require__(1156);

var _round2 = _interopRequireDefault(_round);

var _findKey = __webpack_require__(366);

var _findKey2 = _interopRequireDefault(_findKey);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _reduce = __webpack_require__(976);

var _reduce2 = _interopRequireDefault(_reduce);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _startsWith = __webpack_require__(1157);

var _startsWith2 = _interopRequireDefault(_startsWith);

var _utilities = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    iframeResponsiveWrapper: function iframeResponsiveWrapper() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      (0, _forEach2.default)(context, function (targetElement) {
        if ((0, _startsWith2.default)(targetElement.src, 'https://www.facebook.com/plugins/post.php') && !(0, _utilities.isDesktop)()) {
          targetElement.style.marginBottom = '0px';
          targetElement.setAttribute('height', '430');
          return;
        }

        var availableRatios = {
          '1by1': 1,
          '4by3': (0, _round2.default)(4 / 3, 3),
          '16by9': (0, _round2.default)(16 / 9, 3),
          '21by9': (0, _round2.default)(21 / 9, 3)
        };

        var iframeWidth = targetElement.getAttribute('width');
        var iframeHeight = targetElement.getAttribute('height');

        if (iframeWidth && iframeHeight) {
          iframeWidth = (0, _head2.default)(iframeWidth.match(/[0-9]+/));
          iframeHeight = (0, _head2.default)(iframeHeight.match(/[0-9]+/));
          var ratio = iframeWidth / iframeHeight;

          if (ratio >= 1 && !targetElement.classList.contains('embed-responsive-item')) {
            var closest = (0, _reduce2.default)((0, _map2.default)((0, _keys2.default)(availableRatios), function (o) {
              return availableRatios[o];
            }), function (prev, curr) {
              return Math.abs(curr - ratio) < Math.abs(prev - ratio) ? curr : prev;
            });
            var ratioClass = (0, _findKey2.default)(availableRatios, function (o) {
              return o === closest;
            });

            targetElement.classList.add('embed-responsive-item');
            var wrapper = document.createElement('div');
            wrapper.classList.add('embed-responsive', 'embed-responsive-' + ratioClass);
            var parentNode = targetElement.parentNode;
            wrapper.appendChild(targetElement);
            parentNode.appendChild(wrapper);
          }
        }
      });
    }
  }
};

/***/ }),

/***/ 1155:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),

/***/ 1156:
/***/ (function(module, exports, __webpack_require__) {

var createRound = __webpack_require__(964);

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

module.exports = round;


/***/ }),

/***/ 1157:
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(1155),
    baseToString = __webpack_require__(111),
    toInteger = __webpack_require__(147),
    toString = __webpack_require__(25);

/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = toString(string);
  position = position == null
    ? 0
    : baseClamp(toInteger(position), 0, string.length);

  target = baseToString(target);
  return string.slice(position, position + target.length) == target;
}

module.exports = startsWith;


/***/ }),

/***/ 1167:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1382),
  /* template */
  __webpack_require__(1730),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _iframeResponsiveWrapper = __webpack_require__(1120);

var _iframeResponsiveWrapper2 = _interopRequireDefault(_iframeResponsiveWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'body-iframe',
  props: ['item'],
  mixins: [_iframeResponsiveWrapper2.default],
  mounted: function mounted() {
    var _this = this;

    this.$watch('$refs.iframeLazy.state.loaded', function () {
      if (_this.$refs.iframeLazy.state.loaded) {
        _this.iframeResponsiveWrapper([_this.$refs.iframe]);
      }
    });
  }
};

/***/ }),

/***/ 1730:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('lazy-component', {
    ref: "iframeLazy",
    staticClass: "iframe-lazy-wrapper",
    attrs: {
      "tag": "div"
    }
  }, [_c('iframe', _vm._b({
    ref: "iframe"
  }, 'iframe', _vm.item.content.attr, false))])
},staticRenderFns: []}

/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(147),
    toNumber = __webpack_require__(339),
    toString = __webpack_require__(25);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
    if (precision) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

module.exports = createRound;


/***/ })

});


// WEBPACK FOOTER //
// 30.6686caa581f9f156ee80.js